<div class="layout-footer">
    <div class="grid" style="width: 100%;">
        <div class="col-6">{{ repoName }}
        </div>
        <div class="col-6 footer-copyright">
            {{date | date : "yyyy"}} © everyDataStore powerd by <a href="https://www.everydatastore.de" target="_blank">everyDataStore GmbH.</a>
        </div>
    </div>
</div>
